export enum AnalyticsActions {
  GET_ITEMS = 'GET_ANALYTIC_ITEMS',
  SET_ITEMS = 'SET_ANALYTIC_ITEMS',
  SET_FILTERS = 'SET_ANALYTIC_FILTERS',
  CLEAR_FILTERS = 'CLEAR_ANALYTIC_FILTERS',
  SET_LOADING = 'SET_ANALYTICS_LOADING',
  CLEAR_DATA = 'CLEAR_ANALYTICS_DATA'
}